import { memo } from 'react'
import { Box } from '@astro-ui/components'
import styled from 'styled-components'

import type { BoxPropsType } from '../Box'

export type CardPropsType = BoxPropsType & {
  padding?: string
}

const Card = styled(Box)<CardPropsType>`
  padding: ${({ padding }) => padding || '24px'};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
`

export default memo(Card)
